import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card1.scss';

class Card1 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Ações emergenciais marcam atuação na pandemia - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card1-home page-gradient page-gradient--yellow bg-gray" ref="card1-home">
          <section className="iniciativas-area card1-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Ações emergenciais marcam atuação na pandemia</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-8">
                              <p>
                                Com o avanço da pandemia e das medidas de distanciamento social, especialmente o
                                trabalho remoto, a pauta da Associação, no primeiro momento, girou em torno de medidas
                                capazes de mitigar os impactos no dia a dia das instituições, dada a complexidade do
                                cenário. Nossas ações foram direcionadas para questões de natureza operacional e
                                estrutural.
                              </p>
                              <p>
                                As questões operacionais diziam respeito, principalmente, aos prazos para cumprimento de
                                obrigações regulatórias. O diálogo com as autoridades competentes – CVM, Banco Central e
                                Receita Federal – foi intensificado e boa parte das sugestões do mercado foi acatada,
                                como a prorrogação de prazos para entrega de documentos (veja mais em{' '}
                                <DelayLink to="/iniciativa/pandemia-acelera-agenda">
                                  Pandemia acelera agenda de mercado de capitais
                                </DelayLink>
                                ).
                              </p>
                            </div>
                            <div className="col-4 img-center h-img">
                              <img src={images.iniciativas.card1.img1} className="img1" />
                              <img src={images.iniciativas.card1.anima1} className="anima1" />
                              <img src={images.iniciativas.card1.anima2} className="anima2" />
                            </div>
                          </div>

                          <div className="col-12">
                            <p>
                              Dentro de casa, flexibilizamos uma série de regras previstas nos nossos códigos de
                              melhores práticas: mais de 50 itens tiveram prazos estendidos ou exigências facilitadas,
                              sem prejuízo para o mercado. O calendário de provas de certificação foi suspenso e todo o
                              portfólio de cursos online foi disponibilizado gratuitamente (veja mais em{' '}
                              <DelayLink to="/iniciativa/suspensao-provas">Suspensão das provas estimula capacitação</DelayLink>).
                            </p>
                            <p>
                              Pelo lado das demandas de natureza estrutural, que impactam o mercado como um todo, as
                              principais foram precificação e liquidez. Diversas reuniões sobre os temas foram
                              conduzidas com os reguladores, envolvendo sugestões tanto de medidas emergenciais como de
                              alteração de regras.
                            </p>
                            <p>
                              Na autorregulação, as diretrizes de liquidez começaram a ser revistas em 2020 e novas
                              regras entram em vigor em 2021. A precificação também mereceu nossa atenção, com a
                              melhoria dos procedimentos de coleta e avaliação das taxas (veja mais em{' '}
                              <DelayLink to="/iniciativa/precificacao-de-ativos-ganha-aprimoramentos">Precificação de ativos ganha aprimoramentos</DelayLink>).
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card1 };
